/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import AcceptAction from './AcceptAction/index'
import AddAction from './AddAction/index'
import Charges from './Charges/index'
import Discounts from './Discounts/index'
import Insurances from './Insurances/index'
import Overlay from './Overlay/index'
import Payors from './Payors/index'
import React from 'react'
import Request from './Request/index'
import Send from './Send/index'
import SendRequestAction from './SendRequestAction/index'
import SignedContracts from './SignedContracts/index'
import Summary from './Summary/index'
import TotalTreatmentFee from './TotalTreatmentFee/index'
import TysiaText from 'DesignSystem/TysiaText/index'
import ViewContractAction from './ViewContractAction/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Patients/Content/Content/Sections/ActiveTab/TreatmentCard/Content/TreatmentPlans/Steps/Content/PaymentPlans/Content/Content/PaymentPlan/Content/Content"
  
}) {
let treatmentPlanItemIsFirstValueData = fromData.useDataValue({ viewPath,
context: 'treatment_plan_item',
path: 'isFirst',
})
let paymentPlanRequestIdValueData = fromData.useDataValue({ viewPath,
context: 'payment_plan',
path: 'request_id',
})
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
let dtSpaceM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.m'
        })
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
let treatmentPlanNameValueData = fromData.useDataValue({ viewPath,
context: 'treatment_plan',
path: 'name',
})
let dtColorsNeutral100 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.100'
        })
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
  return (<React.Fragment
>
<Request
  viewPath={`${viewPath}/Request`}
/>
<SignedContracts
  viewPath={`${viewPath}/SignedContracts`}
/>
<div
  data-testid="Content.Vertical"
  data-view-path={viewPath}
 style={{'--bblr-1-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bbrr-2-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btlr-3-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btrr-4-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--bc-5-Z1Yf8zk': dtColorsWhite,'--bc-6-Z1Yf8zk': dtColorsNeutral200,'--mt-7-Z1Yf8zk': treatmentPlanItemIsFirstValueData ? "0px" : paymentPlanRequestIdValueData ? typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs : typeof dtSpaceM === 'number' ? `${dtSpaceM}px` : dtSpaceM}}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Content.Horizontal"
  data-view-path={viewPath}
 style={{'--pt-8-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pb-9-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pl-10-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-11-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bc-5-Z1Yf8zk': dtColorsNeutral200}}
 className={`views-block ${styles.Horizontal}`}
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 size="large"
 weight="medium"
 data="treatment_plan.name"
 text={treatmentPlanNameValueData}
/>
</div>
<div
  data-testid="Content.Vertical:1"
  data-view-path={viewPath}
 className="views-block"
>
<div
  data-testid="Content.Horizontal:1"
  data-view-path={viewPath}
 style={{'--pt-8-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-9-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-10-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--pr-11-Z1Yf8zk': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS,'--bbc-12-Z1Yf8zk': dtColorsNeutral200}}
 className={`views-block ${styles.Horizontal1}`}
>
<TotalTreatmentFee
  viewPath={`${viewPath}/TotalTreatmentFee`}
/>
<AddAction
  viewPath={`${viewPath}/AddAction`}
/>
</div>
<div
  data-testid="Content.Horizontal:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Horizontal2}`}
>
<div
  data-testid="Content.Vertical:2"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical1}`}
>
<Insurances
  viewPath={`${viewPath}/Insurances`}
/>
<Discounts
  viewPath={`${viewPath}/Discounts`}
/>
<Charges
  viewPath={`${viewPath}/Charges`}
/>
<Payors
  viewPath={`${viewPath}/Payors`}
/>
</div>
<div
  data-testid="Content.Vertical:3"
  data-view-path={viewPath}
 style={{'--blc-13-Z1Yf8zk': dtColorsNeutral200,'--bc-5-Z1Yf8zk': dtColorsNeutral100}}
 className={`views-block ${styles.Vertical2}`}
>
<Summary
  viewPath={`${viewPath}/Summary`}
/>
</div>
</div>
<Overlay
  viewPath={`${viewPath}/Overlay`}
/>
</div>
<div
  data-testid="Content.Horizontal:3"
  data-view-path={viewPath}
 style={{'--pt-8-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pb-9-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pl-10-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--pr-11-Z1Yf8zk': typeof dtSpaceXs === 'number' ? `${dtSpaceXs}px` : dtSpaceXs,'--btc-14-Z1Yf8zk': dtColorsNeutral200,'--g-15-Z1Yf8zk': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Horizontal3}`}
>
<ViewContractAction
  viewPath={`${viewPath}/ViewContractAction`}
/>
<SendRequestAction
  viewPath={`${viewPath}/SendRequestAction`}
/>
<AcceptAction
  viewPath={`${viewPath}/AcceptAction`}
/>
</div>
</div>
<Send
  viewPath={`${viewPath}/Send`}
/>
{children}
</React.Fragment>)
}